import React, { useState } from 'react';
import { Grid } from "@material-ui/core";
import DateRangePicker from "../../../shared/components/DateRangePicker"
import SelecaoMultiplaAuto from "../../../shared/components/SelecaoMultiplaAuto";
import TextFieldPesquisa from "../../../shared/components/TextFieldPesquisa";
import _ from "lodash";

let handleChangeFiltrosRef;

const handleChangeFiltrosDebounce = _.debounce((filtros) => {
    handleChangeFiltrosRef(filtros);
}, 600);

const AmostrasFiltros = ({
    tiposOpcoes,
    statusOpcoes,
    filtros,
    handleChangeFiltros,
}) => {
    const [termoBusca, setTermoBusca] = useState(filtros.busca || "");

    handleChangeFiltrosRef = handleChangeFiltros;

    const handleChangeTermoBusca = (event) => {
        const novoTermo = event.target.value;
        setTermoBusca(novoTermo);

        if (novoTermo.length > 2 || novoTermo.length === 0)
            handleChangeFiltrosDebounce({ ...filtros, busca: novoTermo });
    };

    return (
        <Grid container spacing={3}>

            <Grid item xs={4}>
                <TextFieldPesquisa
                    id="buscarAmostras"
                    label="Buscar por amostra, paciente, pedido ou lote"
                    value={termoBusca}
                    onChange={handleChangeTermoBusca}
                    iconeSeparador={true}
                />
            </Grid>

            <Grid item container xs={5}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelecaoMultiplaAuto
                            options={tiposOpcoes}
                            getOptionLabel={opcao => opcao.descricao}
                            getOptionValue={opcao => opcao.codigo}
                            handleChange={opcao => handleChangeFiltros({ ...filtros, tipos: opcao })}
                            code={filtros.tipos}
                            label="Filtrar por tipo"
                            isClearable
                            multiple
                            returnFullObject
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <SelecaoMultiplaAuto
                            options={statusOpcoes}
                            getOptionLabel={opcao => opcao}
                            getOptionValue={opcao => opcao}
                            handleChange={opcao => handleChangeFiltros({ ...filtros, status: opcao })}
                            code={filtros.status}
                            label="Filtrar por status"
                            isClearable
                            multiple
                            returnFullObject
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={3}>
                <DateRangePicker
                    titulo="Filtrar período cadastro"
                    dataInicial={filtros.dataInicio}
                    dataFinal={filtros.dataFinal}
                    periodoHandler={(dataInicio, dataFinal) => handleChangeFiltros({ ...filtros, dataInicio: dataInicio, dataFinal: dataFinal })}
                    permitirDataFutura={false}
                    showClearDates={true}
                    numberOfMonths={1}
                    small
                    disabled={false}
                    periodoMaximoEmDias={31}
                />
            </Grid>
        </Grid>
    );
}

export default AmostrasFiltros;